import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { BsBoxArrowInUpRight } from 'react-icons/bs';
import { INVOICE_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import PartiallyPaid from './components/PartiallyPaid';
import FullyPaid from './components/FullyPaid';
import Pending from './components/Pending';

const Invoices = () => {
  const [activeTab, setActiveTab] = useState(INVOICE_TABS.UNPAID);
  const navigate = useNavigate();
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[
            INVOICE_TABS.UNPAID,
            INVOICE_TABS.PARTIALLY_PAID,
            INVOICE_TABS.FULLY_PAID,
          ]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab"
        />
        <div
          aria-hidden="true"
          className="view-all-btn ms-auto text-decoration-none text-nowrap"
          onClick={() => navigate('/invoices')}
        >
          View All <BsBoxArrowInUpRight />
        </div>
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={INVOICE_TABS.UNPAID}>
          {activeTab === INVOICE_TABS.UNPAID && (
            <ErrorBoundary>
              <Pending />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={INVOICE_TABS.PARTIALLY_PAID}>
          {activeTab === INVOICE_TABS.PARTIALLY_PAID && (
            <ErrorBoundary>
              <PartiallyPaid />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={INVOICE_TABS.FULLY_PAID}>
          {activeTab === INVOICE_TABS.FULLY_PAID && (
            <ErrorBoundary>
              <FullyPaid />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Invoices;
